import BaseButton from '@material-ui/core/Button';
import styled from 'styled-components';

export const StyledButton = styled(BaseButton)`
  &.MuiButton-containedPrimary:not(.Mui-disabled) {
    border: 2px solid ${(p) => p.theme.sellerTheme.primary.safeContainerColor};
  }

  &.MuiSvgIcon-root {
    fill: ${(p) => p.theme.sellerTheme.primary.safeContainerColor};
  }

  &.MuiButton-outlinedPrimary {
    .MuiButton-label {
      color: ${(p) => p.theme.sellerTheme.primary.safeContainerColor};
    }
  }

  &.MuiButtonGroup-groupedContainedHorizontal:not(:last-child) {
    border-right-color: rgba(0, 0, 0, 0.1);
  }
  white-space: nowrap;
`;
